import { cn } from "../lib/cn";
import { initials } from "../lib/format";

const AVATAR_COLOURS = ["#2F461A", "#4A6530", "#6E8857", "#B85A10", "#3D6F8E", "#8A430C"];

export function Avatar({ name, src, size = 28, className }: { name: string | null | undefined; src?: string | null; size?: number; className?: string }) {
  const idx = name ? [...name].reduce((a, c) => a + c.charCodeAt(0), 0) % AVATAR_COLOURS.length : 0;
  if (src)
    return <img src={src} alt="" referrerPolicy="no-referrer" className={cn("shrink-0 rounded-full object-cover", className)} style={{ width: size, height: size }} />;
  return (
    <span
      aria-hidden
      className={cn("grid shrink-0 place-items-center rounded-full font-bold text-paper", className)}
      style={{ width: size, height: size, background: AVATAR_COLOURS[idx], fontSize: Math.max(10, size * 0.38) }}
    >
      {initials(name)}
    </span>
  );
}
